module.exports = __webpack_public_path__ + "84cfcbdddfefa41db5437ca6da2ac665.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/819.png
// module id = 1722
// module chunks = 2